import { render, staticRenderFns } from "./SpuOnSale.vue?vue&type=template&id=ff05fcc2&scoped=true"
import script from "./SpuOnSale.vue?vue&type=script&lang=js"
export * from "./SpuOnSale.vue?vue&type=script&lang=js"
import style0 from "./SpuOnSale.vue?vue&type=style&index=0&id=ff05fcc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff05fcc2",
  null
  
)

export default component.exports